module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Deuce-The-S1.48e63f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Deuce-The-S1.jpg
// module id = Dk0+
// module chunks = 0